export const Stripe = {
  instance: null,
  elements: null
};

// Stripe elements 全体のオプション
// refs: https://stripe.com/docs/stripe-js/reference#stripe-elements
const STRIPE_ELEMENTS_OPTIONS = {
  fonts: [
    {
      cssSrc: 'https://fonts.googleapis.com/css?family=Lato:400&display=swap'
    }
  ],
  locale: 'en'
};

// Stripe element 個別要素のオプション
// refs: https://stripe.com/docs/stripe-js/reference#elements-create
const STRIPE_SPECIFIC_ELEMENT_OPTIONS = {
  classes: {
    base: 'form-ctl',
    focus: 'focus',
    invalid: 'error',
    complete: 'valid'
  },
  style: {
    base: {
      fontSize: '16px',
      fontWeight: 400,
      fontFamily: 'Lato, Open Sans, sans-serif',
      fontSmoothing: 'antialiased',
      '::placeholder': {
        color: '#b0b0b0'
      }
    }
  }
  // 'card' element の場合のみ指定可能
  // hidePostalCode: true
};

function initialize(key, options) {
  if (window.Stripe === undefined) {
    console.error('Stripe V3 library not loaded!');
    return;
  }

  if (Stripe.instance === null) {
    Stripe.instance = window.Stripe(key, { apiVersion: '2024-06-20' });
  }
  if (!Stripe.instance.elements) {
    console.error('Stripe V3 library not loaded!');
  } else if (Stripe.elements === null) {
    Stripe.elements = Stripe.instance.elements(options);
  }
}

export function create(type, key, options = {}) {
  initialize(key, Object.assign({}, STRIPE_ELEMENTS_OPTIONS, options.initialization));

  let element;
  if (type === 'payment') {
    element = Stripe.elements.create(type, options.element);
  } else {
    element = Stripe.elements.create(
      type,
      Object.assign({}, STRIPE_SPECIFIC_ELEMENT_OPTIONS, options.element)
    );
  }

  return element;
}

export function destroy() {
  Stripe.instance = null;
  Stripe.elements = null;
}
